var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-config-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "选择活动", clearable: "" },
                      model: {
                        value: _vm.searchForm.expandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "expandId", $$v)
                        },
                        expression: "searchForm.expandId",
                      },
                    },
                    _vm._l(_vm.actLists, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.activityName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入会员卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cardNo", $$v)
                      },
                      expression: "searchForm.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "膨胀状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待膨胀", value: "-1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "膨胀中", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "膨胀成功", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "膨胀失败", value: "2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center",
                  index: _vm.indexMethod,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "发起人", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(scope.row.mobile) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员卡号", prop: "cardNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "活动名称",
                  prop: "activityName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "膨胀券名称",
                  prop: "couponStartName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "被分享人券名称",
                  prop: "couponShareName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "发起时间/领取时间",
                  prop: "ruleCode",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.createDate))]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(scope.row.receiveDate))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "膨胀状态", prop: "status", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == "-1"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("待膨胀"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "0"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("膨胀中"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "1"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("膨胀成功"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "2"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("膨胀失败"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "210",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("好友明细")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row, 2)
                              },
                            },
                          },
                          [_vm._v("领券用户")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "user-dialog",
          attrs: {
            title: "参与用户列表",
            "close-on-click-modal": true,
            visible: _vm.showUserDialog,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm2 },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "状态", clearable: "" },
                      model: {
                        value: _vm.searchForm2.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm2, "status", $$v)
                        },
                        expression: "searchForm2.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "注册成功", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "领券成功", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getUserList },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.userList, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "参与用户", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(scope.row.mobile || "-") +
                              "\n                    "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardNo", label: "会员卡号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "核销订单号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == "0"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("注册成功"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == "1"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("领券成功"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sueStatus",
                  label: "膨胀券状态",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.sueStatus == "2"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("膨胀券已回退"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.sueStatus == "0"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("膨胀券未发放"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.sueStatus == "1"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("膨胀券已发放"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "注册时间",
                  prop: "registerDate",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveDate",
                  label: "领取时间",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "核销时间", prop: "useDate", align: "center" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm2.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm2.limit,
                  total: _vm.searchForm2.total,
                },
                on: {
                  "current-change": _vm.handlePageChange2,
                  "size-change": _vm.handleSizeChange2,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "领券用户",
            "close-on-click-modal": true,
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm3 },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "用户手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm3.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm3, "mobile", $$v)
                      },
                      expression: "searchForm3.mobile",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "220px", "margin-left": "10px" },
                    attrs: { placeholder: "会员卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm3.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm3, "cardNo", $$v)
                      },
                      expression: "searchForm3.cardNo",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: { placeholder: "状态", clearable: "" },
                      model: {
                        value: _vm.searchForm3.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm3, "status", $$v)
                        },
                        expression: "searchForm3.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "新用户领券", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "老用户领券", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getUserList2 },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.userList2, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "参与用户", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardNo", label: "会员卡号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "优惠券名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponId", label: "优惠券ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.userType == 1
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("新用户领券"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.userType == 2
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("老用户领券"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createDate",
                  label: "领券时间",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm3.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm3.limit,
                  total: _vm.searchForm3.total,
                },
                on: {
                  "current-change": _vm.handlePageChange3,
                  "size-change": _vm.handleSizeChange3,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }